export default {
  ["Дата начала продаж {date}"]: (date?: string) => `Verkaufsstart am ${date}`,
  ["Закрыть"]: "Schließen",
  ["Рекламный слайдер"]: "Werbeslider",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Verwenden Sie die Pfeiltasten, um die Folien zu wechseln.",
  ["Ещё"]: "Mehr",
  ["Ещё {number}"]: (number?: number) => `${number} weitere`,
  ["Убрать"]: "Entfernen",
  ["Меню"]: "Menü",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `Von ${data?.min} bis ${data?.max} Zeichen`,
  ["Минимум {count} символ"]: (count?: number) => `Mindestens ${count} Zeichen`,
  ["Выбрать из списка"]: "Aus der Liste auswählen",
  ["развернуто"]: "Erweitert",
  ["свернуто"]: "Eingeklappt",
  ["Модальное окно"]: "Modalfenster",
  ["Выбран"]: "Ausgewählt",
  ["Не выбран"]: "Nicht ausgewählt",
  ["Свернуть"]: "Einklappen",
  ["Эксклюзив"]: "Exklusiv",
  ["Хит продаж"]: "Bestseller",
  ["Новинка"]: "Neuerscheinung",
  ["Все книги, получившие эту награду"]:
    "Alle Bücher, die diese Auszeichnung erhalten haben",
  ["Предыдущий слайд"]: "Vorherige Folie",
  ["Следующий слайд"]: "Nächste Folie",
  ["Оценить книгу на {count} балл из 5"]: (count: number | undefined = 0) =>
    `Bewerten Sie das Buch mit ${count} ${count > 1 ? "Punkten" : "Punkt"} von 5`,
  ["Снять оценку"]: "Bewertung entfernen",
  ["{star} звезда из 5"]: (star: number | undefined = 0) =>
    `${star} ${star > 1 ? "Sterne" : "Stern"} von 5`,
  ["предыдущий таб"]: "Vorheriger Tab",
  ["следующий таб"]: "Nächster Tab",
};
